<template lang="pug">
div
  Form(:data="behaviour", :isSubmitting="isSubmitting", :isEdit="true", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useBehaviourEdit from './useBehaviourEdit'

export default {
  components: {
    Form,
  },

  setup() {
    const { show, update, behaviour, isSubmitting } = useBehaviourEdit()

    onMounted(show)

    return {
      behaviour,
      update,
      isSubmitting,
    }
  },
}
</script>
